
// import React, { useState, useEffect } from "react";


// import { Outlet } from "react-router-dom";
// import Studentsidebar from "./Studentsidebar";

// const StudentLayout = () => {

//   const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

//   useEffect(() => {

//     const handleResize = () => {
//       setIsDesktop(window.innerWidth >= 992);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);

//   }, []);

//   return (
//     <>
//     <Studentsidebar/>


//       <div
//         className="p-3"
//         style={{
//           marginLeft: isDesktop ? "240px" : "0px",
//           overflowX: "hidden"
//         }}
//       >
//         <Outlet />
//       </div>
//     </>
//   );
// };

// export default StudentLayout;


import React, { useState, useEffect } from "react";
import Studentsidebar from "../Students/Studentsidebar";
import { Outlet } from "react-router-dom";

const StudentLayout = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Studentsidebar />

      <div
        className="p-3"
        style={{
          marginLeft: isDesktop ? "240px" : "0px", 
          paddingTop: "20px",     
          minHeight: "100vh",
          boxSizing: "border-box",
        }}
      >
        <Outlet />
      </div>
    </>
  );
};

export default StudentLayout;